import React, {useEffect} from 'react';
import uuid from 'uuid/v4';

import {randomUserUuid} from '../../graphql/queries';
import {getConversationsList} from '../../graphql/queries';
import {createConvo, createConvoLink} from '../../graphql/mutations';

const fetchConversationsList = async (id: String, client: any) => {
  return await client.query({
    query: getConversationsList,
    fetchPolicy: 'network-only',
    variables: {
      id,
    },
  });
};

const populateConversationList = async ({client, userId}: any) => {
  const data = await fetchConversationsList(userId, client);

  if (!data.data.getUser) {
    // const registerUserData = await client.mutate({
    //   mutation: registerUser,
    //   variables: {
    //     input: {
    //       id: user.id,
    //       registered: true,
    //       username: user.name
    //     }
    //   }
    // });
  }
  const convoList =
    data.data.getUser && data.data.getUser.userConversations.items;

  if (convoList === null) {
    const data: any = await client.mutate({
      mutation: createConvo,
      variables: {
        input: {name: 'direct'},
      },
    });
    const createConvoResponse = data.data.createConvo;
    if (createConvoResponse) {
      const userConvoLink = client.mutate({
        mutation: createConvoLink,
        variables: {
          convoId: createConvoResponse.id,
          userId: userId,
          name: 'AWS',
        },
      });

      const botConvoLink = client.mutate({
        mutation: createConvoLink,
        variables: {
          convoId: createConvoResponse.id,
          userId: 'awsBot',
          name: 'AWS',
        },
      });
    }
  }
};

const getRandomUserUuid = async (
  client: any,
  updateRandUserIdAws: Function
) => {
  //   const apiData = await client.query({
  //     query: randomUserUuid,
  //     fetchPolicy: 'network-only'
  //   });
  //   localStorage.setItem('randUserIdAws', apiData.data.randomUserUuid);
  //   updateRandUserIdAws(apiData.data.randomUserUuid);
  localStorage.setItem('randUserIdAws', uuid());
  localStorage.setItem('Aws', 'true');
  updateRandUserIdAws(uuid());
};

interface IRandomUserIdWrapperProps {
  client: any;
  updateRandUserIdAws: Function;
}

const RandomUserIdWrapper: React.FC<IRandomUserIdWrapperProps> = ({
  client,
  updateRandUserIdAws,
}) => {
  useEffect(() => {
    if (localStorage.getItem('Aws') === null) {
      getRandomUserUuid(client, updateRandUserIdAws);
      localStorage.setItem('Aws', 'true');
    } else {
      updateRandUserIdAws(localStorage.getItem('randUserIdAws'));

      populateConversationList({
        client,
        userId: localStorage.getItem('randUserIdAws'),
      });
    }
  }, [client, updateRandUserIdAws]);
  return <></>;
};

export default RandomUserIdWrapper;
